import type { IAttentionGeoNode } from './types'

/** The node with `itemId` anywhere in `nodes`' subtrees, depth first. */
export const findAttentionGeoNode = (
  nodes: IAttentionGeoNode[],
  itemId: string
): IAttentionGeoNode | null => {
  for (const node of nodes) {
    if (node.itemId === itemId) {
      return node
    }

    const found = findAttentionGeoNode(node.children, itemId)

    if (found) {
      return found
    }
  }

  return null
}
